import React from 'react';
import {
  Redirect,
  Route,
} from 'react-router';
import ShopMainLayout from '../components/ShopMainLayout';
import Choose from './Choose';
import BarberRoutes from './BarberRoutes';
import ServiceRoutes from './ServicesRoutes';
import TimeRoutes from './TimeRoutes';
import { generateUrlString } from '../utils/helpers';
import config from '../../config';

export default () => (
  <Route path="book">
    <Route component={ShopMainLayout}>
      <Route
        component={Choose}
        path={generateUrlString({ shopRoute: '' }, config.urlPatterns.booking)}
      />
    </Route>
    {BarberRoutes(config.urlPatterns.barber)}
    {ServiceRoutes(config.urlPatterns.service)}
    {TimeRoutes(config.urlPatterns.time)}
    {config.bookingFallbackRedirects.map(redirectProps =>
      (<Redirect {...redirectProps} key={redirectProps.from} />)
    )}
  </Route>
);



// WEBPACK FOOTER //
// ./src/app/dynamicBooking/routes.jsx